// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1WPmV","cell":"ColumnAccessor_cell__3qC61","firstCellAccent":"ColumnAccessor_firstCellAccent__3xpx3"};